import { render, staticRenderFns } from "./redeemRecordList.vue?vue&type=template&id=5009cc00&scoped=true&"
import script from "./redeemRecordList.vue?vue&type=script&lang=js&"
export * from "./redeemRecordList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5009cc00",
  null
  
)

export default component.exports